
<template>
  <sdPageHeader :title="$store.state.application.app_detail.title + ' ' + $t('pages.apps.detail.app-detail')">
    <template v-slot:buttons>
      <div class="page-header-actions">
        <a-space>
          <a-tag color="cyan">
            {{ $t('pages.apps.detail.released-version') }}: {{ $store.state.application.app_detail.version }}
          </a-tag>
          <ReviewProcess
            :id="$store.state.application.app_detail.review_process_id"
            :text="
              $store.state.i18n.i_lang == 'en'
                ? $store.state.application.app_detail.review_process_title_en
                : $store.state.application.app_detail.review_process_title
            "
          />
        </a-space>
        <sdButton
          size="small"
          :type="$store.state.application.app_detail.review_process_id == 1 ? 'success' : 'danger'"
          @click="sendReview()"
          v-if="visibleSendReview"
        >
          {{
            $store.state.application.app_detail.review_process_id == 1
              ? $t('pages.apps.review.send-review')
              : $t('pages.apps.review.withdraw-review')
          }}
        </sdButton>
      </div>
    </template>
  </sdPageHeader>
  <Main>
    <a-row :gutter="25">
      <a-col :md="5" :xs="24">
        <a-menu mode="inline">
          <a-menu-item key="genel">
            <router-link :to="{ name: 'detail-general' }">
              {{ $t('pages.apps.detail.general-information') }}
            </router-link>
          </a-menu-item>
          <a-sub-menu key="sub1">
            <template #title>{{ $t('pages.apps.detail.modules') }}</template>
            <a-menu-item-group key="g1">
              <a-menu-item key="1">
                <router-link :to="{ name: 'detail-module-tracking' }">{{
                  $t('pages.apps.detail.tracking-codes')
                }}</router-link>
              </a-menu-item>
              <a-menu-item key="2">
                <router-link :to="{ name: 'detail-module-htmlblock' }">{{
                  $t('pages.apps.detail.html-block')
                }}</router-link>
              </a-menu-item>
              <a-menu-item key="3">
                <router-link :to="{ name: 'detail-module-webservice' }">{{
                  $t('pages.apps.detail.web-service')
                }}</router-link>
              </a-menu-item>
              <a-menu-item key="4">
                <router-link :to="{ name: 'detail-module-setting' }">{{ $t('pages.apps.detail.setting') }}</router-link>
              </a-menu-item>
              <a-menu-item key="5">
                <router-link :to="{ name: 'detail-module-widget' }">{{ $t('pages.apps.detail.widget') }}</router-link>
              </a-menu-item>
            </a-menu-item-group>
          </a-sub-menu>
          <a-menu-item key="price">
            <router-link :to="{ name: 'detail-price' }"> {{ $t('pages.apps.detail.pricing') }} </router-link>
          </a-menu-item>
          <a-menu-item key="package">
            <router-link :to="{ name: 'detail-package' }"> {{ $t('pages.apps.detail.packages') }} </router-link>
          </a-menu-item>
          <a-menu-item key="inputs">
            <router-link :to="{ name: 'detail-inputs' }">{{ $t('pages.apps.detail.setup-screen') }}</router-link>
          </a-menu-item>
          <a-menu-item key="release-notes">
            <router-link :to="{ name: 'detail-release-notes' }"
              >{{ $t('pages.apps.detail.release-notes') }}
            </router-link>
          </a-menu-item>
          <a-menu-item key="images">
            <router-link :to="{ name: 'detail-images' }">{{ $t('pages.apps.detail.images') }} </router-link>
          </a-menu-item>
          <a-menu-item key="seo">
            <router-link :to="{ name: 'detail-seo' }"> {{ $t('pages.apps.detail.seo') }} </router-link>
          </a-menu-item>
          <a-menu-item key="other">
            <router-link :to="{ name: 'detail-other' }"> {{ $t('pages.apps.detail.other') }} </router-link>
          </a-menu-item>
          <a-menu-item key="review" v-if="decoder($store.state.auth.is_root) == 1">
            <router-link :to="{ name: 'detail-review' }">
              {{ $t('pages.apps.detail.release-operations') }}
            </router-link>
          </a-menu-item>
        </a-menu>
      </a-col>
      <a-col :md="19" :xs="24">
        <router-view></router-view>
      </a-col>
    </a-row>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import { mapGetters } from 'vuex';
import ReviewProcess from '@/components/application/ReviewProcess';

export default {
  name: 'BlankPage',
  components: {
    Main,
    ReviewProcess,
  },
  data() {
    return {
      visible_send_review: false,
      app_id: this.$route.params.id,
    };
  },
  methods: {
    decoder(value) {
      return atob(value);
    },
    sendReview() {
      if (!confirm(this.$t('pages.apps.detail.question-process'))) {
        return false;
      }

      this.$appAxios.post(this.$endpoints.app_review_update, { app_id: this.app_id }).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
          this.$store.dispatch('application/setReviewProcess', resp.data.data);
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
  },
  created() {
    this.$store.dispatch('application/get', this.$route.params.id);
  },
  computed: {
    ...mapGetters({
      app: 'application/app_detail',
    }),
    visibleSendReview() {
      var id = this.$store.state.application.app_detail.review_process_id;
      if (id == 1 || id == 2) {
        return true;
      }
      return false;
    },
  },
};
</script>
